import * as React from 'react';
import { Helmet } from 'react-helmet';

import TeamSection from '../components/team_section';

export default class Teampage extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Zapojené spolky - Stužák</title>
        </Helmet>
        <TeamSection />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/teampage/index.jsx